import { createAction, createSlice } from '@reduxjs/toolkit'

const initialState = {
  currentUser: null,
  userProfile: null,
  membership: null,
  // the membership tier of the owner of the game currently being managed.
  // null whenever the viewer is the owner, or outside a managed game, in
  // which case the viewer's own membership applies. read through
  // useEffectiveMembership() rather than directly.
  gameOwnerMembership: null,
  shoppingCart: null,
  root: 'https://app.gamably.com'
}

export const revertAll = createAction('REVERT_ALL')

export const userSlice = createSlice({
  name: 'user',
  initialState,
  extraReducers: (builder) => builder.addCase(revertAll, () => initialState),
  reducers: {
    setCurrentUser: (state, action) => {
        state.currentUser = action.payload
    },
    setUserProfile: (state, action) => {
        state.userProfile = action.payload
    },
    setMembership: (state, action) => {
        state.membership = action.payload
    },
    setGameOwnerMembership: (state, action) => {
        state.gameOwnerMembership = action.payload
    },
    setShoppingCart: (state, action) => {
        state.shoppingCart = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setCurrentUser,
  setUserProfile,
  setMembership,
  setGameOwnerMembership,
  setShoppingCart,
} = userSlice.actions

export default userSlice.reducer